import type { ReactNode } from 'react';

import { Box, IconButton } from '@chakra-ui/react';
import { FiEdit2 } from 'react-icons/fi';

interface MarkdownCustomBlockActionsProps {
  children: ReactNode;
  editLabel: string;
  onEdit?: () => void;
}

export function MarkdownCustomBlockActions({
  children,
  editLabel,
  onEdit,
}: MarkdownCustomBlockActionsProps) {
  return (
    <Box position="relative" h="100%" display="flex" flexDirection="column">
      {onEdit ? (
        <IconButton
          aria-label={editLabel}
          title={editLabel}
          size="xs"
          variant="outline"
          position="absolute"
          top={2}
          right={2}
          zIndex={1}
          onClick={onEdit}
        >
          <FiEdit2 />
        </IconButton>
      ) : null}
      {children}
    </Box>
  );
}
